import { FC } from "react"
import { ReactComponent as Logo } from "../../img/pdc-logo-svg.svg"

interface IProps {}
const PDCLogoContainer: FC<IProps> = () => {
  return (
    <div className="ocs-pdc-logo-container">
      <a href="https://www.pdc.com/" target="_blank" rel="noreferrer">
        <Logo />
      </a>
    </div>
  )
}

export default PDCLogoContainer
